import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import Button from '../../../core/form/Button';
import Select from '../../../core/form/Select';
import Table from '../../../core/form/Table';
import ItemFormContainer from '../../item/components/ItemFormContainer';
import Text from '../../../core/layout/Text';
import AudioPreview from '../../../core/layout/AudioPreview';
import ImagePreview from '../../../core/layout/ImagePreview';
import Tag from '../../../core/layout/Tag';
import { startCase } from 'lodash';
import { browserHistory } from 'react-router';

const MasteryTestListItems = (props) => (
  <Table
    fetching={props.fetching}
    rowClassName={(row) =>
      row.item.status === 'DRAFT' || row.item.status === 'UNPUBLISHED' ? 'table-row-dark' : 'table-row-light'
    }
    columns={[
      {
        label: 'Order',
        path: 'order',
        width: '75px',
        render: (cell, row) => {
          if (row.item.status !== 'DRAFT' || !row.item.parent) {
            return (
              <Select
                label="Order"
                value={row.order}
                onChange={(order) => props.onOrderChange(row.item.id, order)}
                options={range(1, props.items.length + 1).map((value) => ({
                  label: value.toString(),
                  value,
                }))}
              />
            );
          }
          return cell;
        },
      },
      {
        label: 'Text',
        path: 'item.text',
        render: (cell, row) => <Text value={row.item.text ? row.item.text : row.item.title} maxLength={150} />,
      },
      {
        label: 'Type',
        path: 'item.type.name',
        width: '150px',
        render: (cell, row) => (
          <>
            <Tag color={{ DRAFT: 'grey', PUBLISHED: 'green', UNPUBLISHED: 'red' }[row.item.status]}>
              {startCase(row.item.status.toLowerCase())}
            </Tag>
            {cell}
          </>
        ),
      },
      {
        label: 'Audio',
        path: 'item.audio',
        width: '70px',
        render: (cell, row) => (
          <>
            {!!cell && (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <AudioPreview src={cell} />
              </div>
            )}
            {row.item.answers && row.item.answers.length > 0 && row.item.answers.some((a) => a.audio) && (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: row.item.answers.filter((a) => a.audio).length > 1 ? '25px 25px' : '25px',
                  marginTop: 10,
                  gridGap: 5,
                  justifyContent: 'center',
                }}
              >
                {row.item.answers.map((a) => (a.audio ? <AudioPreview src={a.audio} size="sm" /> : null))}
              </div>
            )}
          </>
        ),
      },
      {
        label: 'Image',
        path: 'item.image',
        width: '190px',
        render: (cell, row) => (
          <>
            {!!cell && <ImagePreview src={cell} renderType="image" />}
            {row.item.answers && row.item.answers.length > 0 && row.item.answers.some((a) => a.image) && (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: row.item.answers.filter((a) => a.image).length > 1 ? '80px 80px' : '80px',
                  marginTop: cell ? 10 : 0,
                  gridGap: 5,
                  justifyContent: 'center',
                }}
              >
                {row.item.answers.map((a) =>
                  a.image ? <ImagePreview src={a.image} renderType="image" size="sm" /> : null
                )}
              </div>
            )}
          </>
        ),
      },
      {
        label: 'Actions',
        path: 'action',
        width: '120px',
        render: (cell, row) => (
          <>
            {row.item.status === 'DRAFT' && (
              <>
                <Button icon="delete" onClick={() => props.onDelete(row)} />{' '}
                <Button icon="cloud-upload" onClick={() => props.onPublish(row)} />
              </>
            )}
            {row.item.status === 'PUBLISHED' && (
              <>
                <Button icon="edit" onClick={() => props.onEdit(row)} />{' '}
                <Button icon="cloud-download" onClick={() => props.onUnpublish(row)} />{' '}
                {!!row.item.parent && (
                  <>
                    <Button
                      icon="history"
                      onClick={() =>
                        browserHistory.push(
                          `${browserHistory.getCurrentLocation().pathname}/items/${row.item.id}/history`
                        )
                      }
                    />{' '}
                  </>
                )}
              </>
            )}
            {row.item.status === 'UNPUBLISHED' && (
              <>
                <Button icon="cloud-upload" onClick={() => props.onPublish(row)} />
              </>
            )}
          </>
        ),
      },
    ]}
    rows={props.items}
    expandable
    expandableComponent={(row) => (
      <div style={{ padding: '0px 10px' }}>
        <ItemFormContainer
          itemId={row.item.id}
          itemsTypeUrl="/item-types?allowedForMasteryTest=true"
          endpointUrl={`/mastery-tests/${row.masteryTest}/items`}
          order={row.order}
          showPostPhrase={false}
          disabled={row.item.status === 'PUBLISHED' || props.disabled}
          onSaveSuccess={props.onSaveSuccess}
          isTestItem
        />
      </div>
    )}
  />
);

MasteryTestListItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      masteryTest: PropTypes.string.isRequired,
      item: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSaveSuccess: PropTypes.func.isRequired,
  onOrderChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  onUnpublish: PropTypes.func.isRequired,
};

export default MasteryTestListItems;
